export const hasFieldAnError = (errors, field) => {
    return errors?.hasOwnProperty(field) && errors[field]?.message !== undefined
}

export const getFieldErrorMessage = (errors, field) => {
    return errors[field]?.message
}

export const getInputErrorClasses = (errors, field) => {
    return hasFieldAnError(errors, field) ? 'text-red-900 ring-1 ring-inset ring-red-300' : ''
}

export const getErrorMessageHtml = (errors, field) => {
    return hasFieldAnError(errors, field) ? (
        <p className="mt-2 text-sm text-red-600">
            {getFieldErrorMessage(errors, field)}
        </p>
        ) : ''
}

/**
 * Detects which Laravel validation rule failed from the (English) default
 * message. Returns null when no rule can be inferred.
 */
const inferLaravelRule = (englishMessage) => {
    const s = (englishMessage ?? '').toLowerCase();
    if (s.includes('has already been taken')) return 'unique';
    if (s.includes('must be a valid email')) return 'email';
    if (s.includes('at least') && s.includes('character')) return 'min';
    if (s.includes('confirmation does not match')) return 'confirmed';
    if (s.includes('is required') || s.includes('field is required')) return 'required';
    return null;
};

/**
 * Turn Laravel's `errors: {field: [msg]}` response into i18next translation
 * keys of the form `validation.<field>.<rule>`. The UI layer resolves the
 * actual string via t(). Returns { key, fallbackKey } — fallback is a generic
 * summary key when the specific field.rule combo isn't mapped.
 */
export const validationErrorKey = (errorsObject) => {
    if (!errorsObject || typeof errorsObject !== 'object') return null;
    for (const [field, msgs] of Object.entries(errorsObject)) {
        const first = Array.isArray(msgs) ? msgs[0] : msgs;
        const rule = inferLaravelRule(first);
        if (rule) return {key: `validation.${field}.${rule}`, fallbackKey: 'validation.generic'};
    }
    return {key: 'validation.generic', fallbackKey: 'validation.generic'};
};